export default "__VITE_ASSET__671a473b__"